import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon=({icon,name,...props})=> {
  let IconComponent;
  
  try {
    IconComponent=icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent=null;
  }
  
  // Return null if no icon is found (no fallback warning icon)
  return IconComponent ? React.createElement(IconComponent,props) : null;
};

export default SafeIcon;